import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'
import userUtils from 'utils/user'

import settings from 'settings'

const AccountCircle = settings.icons.account

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(),
  },
}))

const UserIcon = ({
  user,
}) => {
  return user ? (
    <Avatar src={ userUtils.getImage(user) } />
  ) : (
    <AccountCircle />
  )
}

export default UserIcon